import { render } from "./OpdModel.vue?vue&type=template&id=1766a67e"
import script from "./OpdModel.vue?vue&type=script&lang=js"
export * from "./OpdModel.vue?vue&type=script&lang=js"

import "./OpdModel.vue?vue&type=style&index=0&id=1766a67e&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__